var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotesIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.3996 1.99999V8.39999C13.3996 9.28365 12.6833 9.99999 11.7996 9.99999H7.79961L3.79961 13.2V9.99999H2.19961C1.31595 9.99999 0.599609 9.28365 0.599609 8.39999V1.99999C0.599609 1.11634 1.31595 0.399994 2.19961 0.399994H11.7996C12.6833 0.399994 13.3996 1.11634 13.3996 1.99999ZM4.59961 4.39999H2.99961V5.99999H4.59961V4.39999ZM6.19961 4.39999H7.79961V5.99999H6.19961V4.39999ZM10.9996 4.39999H9.39961V5.99999H10.9996V4.39999Z",
    fill: "#686E78",
    fillOpacity: 0.47
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesIcon);
export default __webpack_public_path__ + "static/media/notes-icon.c3d8b016e09330390e76805dc9d35b43.svg";
export { ForwardRef as ReactComponent };